import dynamic from "next/dynamic";
import { BlockRenderer } from ".";

// const CounterUp = dynamic(() => import("@litonarefin/components/MbBlocks/CounterUp"));
const MbButtons = dynamic(() => import("@litonarefin/components/MbBlocks/Buttons"));
const MbButton = dynamic(() => import("@litonarefin/components/MbBlocks/Button"));
//const TestimonialSlider =dynamic(() => import("@litonarefin/components/MbBlocks/TestimonialSlider");

export const masterBlocks = {
  ["master-blocks/buttons"]: (block) => (
    <MbButtons key={block?.id} attributes={block?.attributes}>
      <BlockRenderer blocks={block.innerBlocks} />
    </MbButtons>
  ),

  ["master-blocks/button-child"]: (block) => (
    <MbButton key={block?.id} attributes={block?.attributes} />
  ),
};
